import Hosts from '../../../../Hosts';

const object_type = 'store/carrier/shipping'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/${object_type}/${companycode}`

const base_endpoint = '/store_shipping_carrier'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    //view: `${base_endpoint}_view`,
    view: `${base_endpoint}`,
}

const data_interface = {
    id: '',
    info: {
        companycode: '',
        name: '',
        transit_time: '',
        media: {
            image: [], 
            doc: []
        },
        tracking_url: '',
        handling_costs: '',
        free_shipping: {
            value: '',
            weight: ''
        },
        billing_type: '',
        taxe: {
            id: '',
            name: '',
            rate: ''
        },
        out_range: '',
        ranges: [{
            min: '0',
            max: '1',
            values: []
        }],
        max_package: {
            width: '',
            height: '',
            depth: '',
            wight: ''
        },
        access: [],
        language: [],
        status: true,
    }
}
export {
    endpoints,
    object_type,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}